"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const typesConstants_1 = require("../../constants/typesConstants");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const styles_1 = __importDefault(require("../../styles/styles"));
const ticketConstants_1 = require("../../features/ticket/ticketConstants");
const ticketFormFields_1 = __importDefault(require("./ticketFormFields"));
const ticketSlice_1 = require("../../features/ticket/ticketSlice");
const ticketUtils_1 = require("./ticketUtils");
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const spinner_1 = __importDefault(require("../spinner/spinner"));
const communicationBoxUtils_1 = require("../communicationBox/communicationBoxUtils");
const TicketForm = ({ ticket, user, readonly }) => {
    let alert = react_1.default.createElement(react_1.default.Fragment, null);
    const dispatch = useAppDispatch_1.default();
    const { callerInbound, loadingStatus, errorMessage } = useAppSelector_1.default((state) => ({
        callerInbound: state.communication.callerInbound,
        loadingStatus: state.ticket.loadingStatus,
        errorMessage: state.ticket.errorMessage,
    }));
    const phoneNumber = communicationBoxUtils_1.parseInboundContact(callerInbound);
    const defaultUser = {
        user_uuid: '',
        first_name: '',
        last_name: '',
        phone_number: phoneNumber,
        email: '',
    };
    const safeUser = user || defaultUser;
    const [displayAlert, setDisplayAlert] = react_1.useState(false);
    const [initialPayload, setInitialPayload] = react_1.useState({});
    const fields = new Map(ticketConstants_1.TICKET_FIELDS.map(({ key, value }) => [key, value]));
    const ticketArrayFields = Array.from(fields.entries());
    // Reduce fields for quick fills for customer support on creation.
    const supportCreateTicketArrayFields = ticketArrayFields.filter(([key]) => ticketConstants_1.SUPPORT_CREATE_TICKET_FIELDS.includes(key));
    const arrayFields = ticket === null ? supportCreateTicketArrayFields : ticketArrayFields;
    react_1.useEffect(() => {
        setInitialPayload({
            ...ticketUtils_1.generateInitialPayload(ticket),
            ...(ticket === null && {
                customer_id: safeUser.user_uuid,
                name: `${safeUser.first_name} ${safeUser.last_name}`.trim(),
                phone_number: safeUser.phone_number,
                email: safeUser.email,
                description: 'nil',
            }),
        });
    }, [user, ticket]);
    if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS) {
        alert = (react_1.default.createElement(react_native_paper_1.Chip, { style: [styles_1.default.blueBackground], textStyle: styles_1.default.textColorWhite, onClose: () => setDisplayAlert(false), icon: "check" }, ticket ? 'Ticket was updated successfully' : 'Ticket was created successfully'));
    }
    else if (loadingStatus === typesConstants_1.FAILED_STATUS) {
        alert = (react_1.default.createElement(react_native_paper_1.Chip, { style: styles_1.default.redBackground, textStyle: styles_1.default.textColorWhite, onClose: () => setDisplayAlert(false), icon: "alert-decagram" }, errorMessage));
    }
    const onSubmit = (values) => {
        if (ticket) {
            // Handle update logic
            dispatch(ticketSlice_1.updateTicket({
                ...values,
                ticket_id: ticket.id,
            }));
            return;
        }
        // Handle create logic
        dispatch(ticketSlice_1.createTicket({
            ...values,
        }));
        // Display alert if there is any message
        setDisplayAlert(true);
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionColumn, styles_1.default.marginTen, styles_1.default.boxStyles] }, loadingStatus === typesConstants_1.PENDING_STATUS ? (react_1.default.createElement(spinner_1.default, null)) : (react_1.default.createElement(formik_1.Formik, { initialValues: initialPayload, enableReinitialize: true, onSubmit: (values) => onSubmit(values), validate: ticketUtils_1.validate }, ({ handleSubmit, handleChange, values }) => (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginFive },
            displayAlert && alert,
            react_1.default.createElement(ticketFormFields_1.default, { values: values, handleChange: handleChange, fields: arrayFields })),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTopTen },
            react_1.default.createElement(button_1.default, { fill: true, text: ticket ? 'Update Ticket' : 'Create', icon: free_solid_svg_icons_1.faFolderOpen, onPress: handleSubmit, disabled: readonly, eventName: ticket ? eventConstants_1.UPDATE_TICKET_BUTTON : eventConstants_1.CREATE_TICKET_BUTTON }))))))));
};
TicketForm.defaultProps = {
    readonly: false,
    user: null,
};
exports.default = TicketForm;
